import { render, staticRenderFns } from "./PurchaseProduct.vue?vue&type=template&id=62329c53"
import script from "./PurchaseProduct.vue?vue&type=script&lang=js"
export * from "./PurchaseProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports